import loadable from '@loadable/component'
import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import MaterialButton from './MaterialButton'
import formatUpdatedAtDate from 'utils/formatUpdatedAtDate'
const PDFViewer = loadable(() => import('./PDFViewer'))
interface Props {
	image: IGatsbyImageData
	grade: number
	writers?: string
	wordStudy?: string
	updatedAt?: (string | undefined)[]
}

const WritersNotebook = ({ image, grade, writers, wordStudy, updatedAt }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Notebooks K-1" }) {
				title
				description {
					description
				}
				image {
					gatsbyImageData(placeholder: BLURRED)
				}
			}
		}
	`)

	function checkIfGradeIsKOr1(grade: number) {
		if (grade === 0) return "Letter Study & Writer's Notebook"
		if (grade === 1) return "Word Study & Writer's Notebooks"
	}

	const title = grade === 0 || grade === 1 ? checkIfGradeIsKOr1(grade) : data.contentfulModal.title
	const description = data.contentfulModal.description.description
	let pages = []
	if (grade === 0) pages = data.contentfulModal.image[0].gatsbyImageData
	else pages = data.contentfulModal.image[1].gatsbyImageData

	function determineSubtitle() {
		if (!updatedAt) return ''
		if (grade === 1 && writers && wordStudy && updatedAt[0] && updatedAt[1]) return `Updated ${formatUpdatedAtDate(updatedAt[0])} & ${formatUpdatedAtDate(updatedAt[1])}`
		if (grade === 0 && writers && updatedAt[0]) return `Updated ${formatUpdatedAtDate(updatedAt[0])}`
	}

	return (
		<React.Fragment>
			<MaterialButton onClick={handleShow} image={image} title={title} />
			<Modal title={title} subTitle={determineSubtitle()} isOpen={show} handleClose={handleClose} wide>
				{!writers && !wordStudy && (
					<Row>
						<Col>
							<p className="text-lg text-slate-400">{description}</p>
						</Col>
						<Col>
							<GatsbyImage image={pages} alt={title} />
						</Col>
					</Row>
				)}

				<Tabs selectedTabClassName="text-ab-100 border-ab-100">
					<TabList className="mb-6 block flex-wrap sm:flex">
						{writers && <Tab className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">Writer's Notebook</Tab>}
						{wordStudy && (
							<Tab className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-xl">
								{!grade ? 'Letter' : 'Word'} Study Notebook
							</Tab>
						)}
					</TabList>
					{writers && (
						<TabPanel className="px-4">
							<PDFViewer pdf={writers} />
						</TabPanel>
					)}
					{wordStudy && (
						<TabPanel className="px-4">
							<PDFViewer pdf={wordStudy} />
						</TabPanel>
					)}
				</Tabs>
			</Modal>
		</React.Fragment>
	)
}

export default WritersNotebook
